<template>
  <div class="main-wrapper flight-booking">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <h2>Dreams Flights</h2>
            </div>
            <div class="inv-header-right">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
            </div>
          </div>
          <div class="flight-invoice-details">
            <h3>Tax Invoice</h3>
            <div class="invoice-infomation">
              <div>Date: <span>05/12/2022</span></div>
              <div>Journey Date: <span>05/01/2023</span></div>
              <div>Invoice No: <span>#00001</span></div>
            </div>
          </div>

          <div class="invoice-address">
            <div class="invoice-to">
              <span>Bill To:</span>
              <div class="inv-to-address">
                Walter Roberson<br />
                299 Star Trek Drive, Panama City, <br />
                Florida, 32405, USA.<br />
                walter@example.com <br />
                +45 5421 4523
              </div>
            </div>
            <div class="invoice-to">
              <span>Pay To:</span>
              <div class="inv-to-address">
                Lowell H. Dominguez<br />
                84 Spilman Street, London<br />
                United Kingdom<br />
                lowell@example.com<br />
                +45 5421 2154
              </div>
            </div>
          </div>
          <div class="passenger-info">
            <div class="passenger-details">
              <h5>Passenger & Ticket infomation</h5>
              <div>Passenger Name <span>Jennifer Richards </span></div>
              <div>Ticket Number<span>#SM75692</span></div>
              <div>Issued By Date <span>05 Feb 2022</span></div>
              <div>Booking Reference<span>HC76SW</span></div>
            </div>
            <div class="payment-info me-0">
              <h5>Payment Information</h5>
              <div>Payment Gatway <span>American Express </span></div>
              <div>Date<span>25 Dec 2022</span></div>
              <div>Transaction ID <span>SI2534687</span></div>
              <div>Total Amount<span> $2440</span></div>
            </div>
          </div>
          <div class="invoice-table">
            <h6 class="invoice-title">Travel Information</h6>
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="table_width_1">#</th>
                    <th class="table_width_2">Flight Details</th>
                    <th class="text-center">Class</th>
                    <th class="text-center">Base Fare</th>
                    <th class="text-end table_width_4">Tax Amount</th>
                    <th class="text-end table_width_4">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td class="table-description">
                      Air canada 1S-2539 Toronto- New York<span
                        >Date: 25 Dec 2022, Sat 8:30AM</span
                      >
                    </td>
                    <td class="text-center">Business Seat</td>
                    <td class="text-center">15,677.15</td>
                    <td class="text-end">2,821.88(18%)</td>
                    <td class="text-end">18,499.00</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="table-description">
                      Air canada 1S-2539 Toronto- New York<span
                        >Date: 25 Dec 2022, Sat 8:30AM</span
                      >
                    </td>
                    <td class="text-center">Economy Seat</td>
                    <td class="text-center">2,541.53</td>
                    <td class="text-end">457.48(18%)</td>
                    <td class="text-end">2,999.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes"></div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>Taxable Amount</td>
                    <td>₹18,218.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes">
              <span></span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>IGST 18.0%</td>
                    <td>₹3,279.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer totalamount-footer">
            <div class="table-footer-left">
              <span class="total-item">Total Items / Qty : 2 / 2.00</span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Total</td>
                    <td class="invoice-title">₹21,498.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer payable-table">
            <div class="table-footer-left notes">
              Total amount ( in words):
              <span> $ Twenty-One Thousand, Four Hundred and Ninety-Eight Only.</span>
            </div>
            <div class="text-end table-footer-right amount-payable">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Amount Payable</td>
                    <td class="invoice-title">₹21,498.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="bank-details">
            <div class="payment-info">
              <span class="payment-title">Payment Info:</span>
              <div><span>Debit Card :</span> 465 *************645</div>
              <div><span>Amount :</span> $1,815</div>
            </div>
            <div class="company-sign">
              <span>For Dreamguys</span>
              <img src="@/assets/img/signature.png" alt="" />
            </div>
          </div>
          <div class="terms-condition">
            <span>Terms and Conditions:</span>
            <p>
              Here we can write a additional notes for the client to get a better
              understanding of this invoice.
            </p>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
